<template>
    <v-dialog
        v-model="dialog"
        max-width="500px"
        scrollable
    >
        <v-card flat color="#004889">
            <v-card-title class="accent">
                <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text class="pa-0">
                <ValidationObserver ref="observer1">
                    <v-form ref="warrantyform">
                        <v-list flat color="#004889" class="py-0">
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Title</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <ValidationProvider v-slot="{ errors }" name="Title" rules="required">
                                        <v-text-field
                                        v-model="editedItem.title"
                                        label="Title"
                                        :error-messages="errors"
                                        required
                                        solo
                                        flat
                                        dark
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-form>
                </ValidationObserver>
            </v-card-text> 

            <v-card-actions class="accent">
                <v-btn
                large min-width="49%" color="white" text
                @click="close"
                >
                Cancel
                </v-btn>
                <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
                >
                Save
                </v-btn>
            </v-card-actions>
            <v-card-text class="pa-0">
                <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row" v-for="category in categories" :key="category.id" dark>
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">{{ category.title }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="justify-end">
                            <v-btn icon @click="deleteCat(category.id)" class="red">
                                <v-icon color="white">mdi-delete</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card-text> 
        </v-card>
    </v-dialog>
</template>
<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import { mapActions } from 'vuex'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        props: ['dialog', 'type'],
        data: () => ({
            loading: false,
            editedItem: {
                title: '',
                type: '',
                description: '',
            },
            categories: []
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            formTitle () {
                return 'New Category'
            },
            manageTitle () {
                if(this.type == 'media')
                    return 'Manage Media Categories'
                else if(this.type == 'chat')
                    return 'Manage Chat Categories'
                else if(this.type == 'job')
                    return 'Manage Job Categories'
                else
                    return ''
            },
        },

        watch: {
            dialog (val) {
                this.editedItem.title = ''
                this.$emit('update-dialog', val)
            },
        },

        created () {
            this.editedItem.type = this.type
            this.getCategories()
        },

        methods: {
            ...mapActions({
                getData: 'data/getData',
            }),
            close() {
                this.$emit('update-dialog', false)
            },
            getCategories() {
                this.loading = true
                axios.get('crm/category/field/get?type=' + this.type)
                    .then(response => {
                        this.loading = false
                        this.categories = response.data
                        this.$nextTick()
                    })
            },
            deleteCat (id) {
                this.loading = true
                axios.delete('crm/category/field/delete?id=' + id)
                    .then(() => {
                      this.getCategories()
                      this.$nextTick()
                    })
            },
            async save () {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    axios.post('crm/category/field/add', this.editedItem).then(response => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.getCategories()
                        this.getData()
                        this.$emit('update-categories', response.data)
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },
        },
    }
</script>